import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agent-summaries-container',
  templateUrl: './summaries-container.component.html',
})
export class AgentSummariesContainerComponent implements OnInit {
  ngOnInit(): void {}
}
